<div class="container-fluid customers-root">



  <div class="view-details-container" *ngIf="detailsShowed">
    <app-add-installation
        *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter"
        [isPopUp]="true"
        (closePopUpChange)="detailsShowed = false; reloadTable()"
    ></app-add-installation>
    <app-add-dt-installation
        *ngIf="selectedMeterTab === MeterTypeTab.DtMeter"
        [isPopUp]="true"
        (closePopUpChange)="detailsShowed = false; reloadTable()"
    ></app-add-dt-installation>
  </div>
  <div class="d-flex justify-content-end meter-type-tabs">
    <div *ngIf="permissionsService.hasDashboardConfigInstallation && permissionsService.isInstallationViewAllowed"
      class="meter-type-tab" [ngClass]="{ active: selectedMeterTab === MeterTypeTab.CustomerMeter }"
      (click)="setMeterTab(MeterTypeTab.CustomerMeter)">
      <span>{{ 'INSTALLATIONS.CUSTOMER_METER' | translate }}</span>
    </div>
    <div *ngIf="permissionsService.hasDashboardConfigDtMeterInstallation && permissionsService.isDtMeterInstallationViewAllowed"
      class="meter-type-tab" [ngClass]="{ active: selectedMeterTab === MeterTypeTab.DtMeter }"
      (click)="setMeterTab(MeterTypeTab.DtMeter)">
      <span>{{ 'INSTALLATIONS.DT_METER' | translate }}</span>
    </div>
  </div>

  <app-card-analytics *ngIf="!invoiceTab" [stats]="stats" [reset]="reset" (shareFilterValue)="onFilterBy($event)"></app-card-analytics>

  <div class="table-root">
    <div class="d-flex justify-content-start switch-toggle transparent">
      <a
        class="separated-toggle-item"
        [ngClass]="!invoiceTab && currentTab == 4 ? 'active' : ''"
        (click)="changeTab(4);reset = !reset"
        ><div>
          <span class="bubble">{{ countAssigned | number }}</span> {{'COMMON.ASSET_STATUS.ASSIGNED' | translate}}
        </div></a
      >
      <a class="separated-toggle-item" [ngClass]="!invoiceTab && currentTab == 1 ? 'active' : ''" (click)="changeTab(1);reset = !reset"><div><span class="bubble">{{countSubmited + countResubmitted | number}}</span> {{'COMMON.ASSET_STATUS.SUBMITTED' | translate}}</div></a>
          <a class="separated-toggle-item" [ngClass]="!invoiceTab && currentTab == 2 ? 'active' : ''" (click)="changeTab(2);reset = !reset"><div><span class="bubble">{{countApproved | number}}</span> {{'COMMON.ASSET_STATUS.APPROVED' | translate}}</div></a>
          <a class="separated-toggle-item" [ngClass]="!invoiceTab && currentTab == 3 ? 'active' : ''" (click)="changeTab(3);reset = !reset"><div><span class="bubble">{{countRejected | number}}</span> {{'COMMON.ASSET_STATUS.REJECTED' | translate}}</div></a>

      <ng-container *ngIf="selectedMeterTab === MeterTypeTab.DtMeter">
          <a *ngIf="permissionsService.isDtMeterInstallationViewMeterApprovalAllowed && permissionsService.hasDashboardConfigMeterApprovalAndRepayment"
           class="separated-toggle-item" [ngClass]="!invoiceTab && currentTab == 8 ? 'active' : ''" (click)="changeTab(8);reset = !reset"><div><span class="bubble">{{countAwaitingApproval | number}}</span> {{'COMMON.ASSET_STATUS.AWAITING_APPROVAL' | translate}}</div></a>
          <a *ngIf="permissionsService.isDtMeterInstallationViewInvoiceApprovalAllowed && permissionsService.hasDashboardConfigMeterApprovalAndRepayment"
           id="installation_invoice-tab_approval" class="separated-toggle-item" [ngClass]="invoiceTab == DtMeterInstallationInvoiceStatus.Approval ? 'active' : ''" (click)="setInvoiceTab(DtMeterInstallationInvoiceStatus.Approval)"><div><span class="bubble">{{countInvoiceApproval | number}}</span> {{'INSTALLATIONS.INVOICE.TABS.APPROVAL' | translate}}</div></a>
          <a *ngIf="permissionsService.isDtMeterInstallationViewActiveRepaymentAllowed && permissionsService.hasDashboardConfigMeterApprovalAndRepayment"
           id="installation_invoice-tab_active" class="separated-toggle-item" [ngClass]="invoiceTab == DtMeterInstallationInvoiceStatus.Active ? 'active' : ''" (click)="setInvoiceTab(DtMeterInstallationInvoiceStatus.Active)"><div><span class="bubble">{{countInvoiceActive | number}}</span> {{'INSTALLATIONS.INVOICE.TABS.ACTIVE' | translate}}</div></a>
          <a *ngIf="permissionsService.isDtMeterInstallationViewCompletedPaymentAllowed && permissionsService.hasDashboardConfigMeterApprovalAndRepayment"
           id="installation_invoice-tab_completed" class="separated-toggle-item" [ngClass]="invoiceTab == DtMeterInstallationInvoiceStatus.Completed ? 'active' : ''" (click)="setInvoiceTab(DtMeterInstallationInvoiceStatus.Completed)"><div><span class="bubble">{{countInvoiceCompleted | number}}</span> {{'INSTALLATIONS.INVOICE.TABS.COMPLETED' | translate}}</div></a>
        </ng-container>
      </div>

    <div class="table-root-child" *ngIf="invoiceTab">
      <div class="table-action-wrapper d-flex align-items-center justify-content-between">
        <div id="installation_invoice_search" class="search-input">
          <img
            src="../../assets/icons/search.svg"
            alt="Search icon"
            (click)="invoiceSearch()"
          />
          <input
            type="text"
            [placeholder]="'COMMON.SEARCH' | translate"
            [(ngModel)]="invoiceSearchText"
            (keydown.enter)="invoiceSearch()"
            (ngModelChange)="this.invoiceSearchTextUpdate.next($event)"
          />
        </div>
        <div class="ml-auto d-flex">
          <div>
            <div class="d-flex">
              <div id="installation_invoice_date-from" class="datepicker-container" style="width: 24rem;">
                <label for="invoiceDateFrom"> {{'COMMON.FROM' | translate}}: </label>
                <input
                  type="date"
                  id="invoiceDateFrom"
                  name="invoiceDateFrom"
                  [ngClass]="
                    invoiceDateFrom > invoiceDateTo
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  "
                  [(ngModel)]="invoiceDateFrom"
                  (change)="invoiceDatesValid() == true && invoiceSearch()"
                />
              </div>

              <div id="installation_invoice_date-to" class="datepicker-container">
                <label for="invoiceDateTo" class="right-label"> {{'COMMON.TO' | translate}}: </label>
                <input
                  type="date"
                  id="invoiceDateTo"
                  name="invoiceDateTo"
                  [ngClass]="
                    invoiceDateFrom > invoiceDateTo
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  "
                  [(ngModel)]="invoiceDateTo"
                  (change)="invoiceDatesValid() == true && invoiceSearch()"
                />
              </div>
            </div>
          </div>
          <div
            id="installation_invoice_sort-by"
            class="sort-by-root"
            (click)="showInvoiceSortBy = !showInvoiceSortBy"
            click-stop-propagation
          >
            <div class="dropdown">
              <span>{{'COMMON.SORT_BY.TITLE' | translate}}:</span>
              <span>{{ invoiceSortByName | translate }}</span>
              <span
                ><img
                  src="../../assets/icons/gray-arrow-down.svg"
                  alt="Gray arrow down"
              /></span>
            </div>
            <div class="dropdown-opened" *ngIf="showInvoiceSortBy">
              <div id="installation_invoice_sort-by-newest" (click)="invoiceSortBy(invoiceSortByOptions.NEWEST)">{{'COMMON.SORT_BY.NEWEST' | translate}}</div>
              <div id="installation_invoice_sort-by-oldest" (click)="invoiceSortBy(invoiceSortByOptions.OLDEST)">{{'COMMON.SORT_BY.OLDEST' | translate}}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="filter">
        <div class="filter-list">
          {{'COMMON.FILTER' | translate}}
          <select id="installation_invoice_period_filter" name="invoice-period-select" (change)="selectInvoicePeriod($event)" class="form-select" >
            <option value="-1" [selected]="invoiceMonth == 0 && invoiceYear == 0" disabled>{{'INSTALLATIONS.INVOICE.PERIOD' | translate}}</option>
            <option [id]="'installation_invoice_period_filter-' + (i + 1)" [selected]="invoiceMonth == o.month && invoiceYear == o.year" *ngFor="let o of invoicePeriods; let i = index" value="{{i}}">
                {{o.label}}
            </option>
          </select>
          <select id="installation_invoice_vendor_filter" name="invoice-vendor-select" (change)="selectInvoiceVendor($event)" class="form-select" >
            <option value="0" [selected]="invoiceOrganizationId == 0" disabled>{{'INSTALLATIONS.INVOICE.VENDOR' | translate}}</option>
            <option [id]="'installation_invoice_vendor_filter-' + (i + 1)" [selected]="invoiceOrganizationId == o.id" *ngFor="let o of organizations; let i = index" value="{{o.id}}">
                {{o.name}}
            </option>
          </select>
        </div>
        <div *ngIf="invoiceSelectedFilters.length > 0">
          <app-filter-checklist [filters]="invoiceSelectedFilters"
                                (resetFilterEmitter)="resetInvoiceFilter(true)"
                                (removeFilterEmitter)="removeInvoiceFilter($event)"
                                >
          </app-filter-checklist>
        </div>
      </div>
      <div class="table">
        <div class="table-scroll">
          <table class="table border-bottom">
            <thead class="table-light">
              <tr>
                <th id="installation_invoice_table_header_invoice-id">{{'INSTALLATIONS.INVOICE.INVOICE_ID' | translate}}</th>
                <th id="installation_invoice_table_header_invoice-date">{{'INSTALLATIONS.INVOICE.INVOICE_DATE' | translate}}</th>
                <th id="installation_invoice_table_header_vendor">{{'INSTALLATIONS.INVOICE.VENDOR' | translate}}</th>
                <th id="installation_invoice_table_header_meter-price">{{'INSTALLATIONS.INVOICE.METER_PRICE' | translate}}</th>
                <th id="installation_invoice_table_header_no-of-meters">{{'INSTALLATIONS.INVOICE.NO_OF_METERS' | translate}}</th>
                <th id="installation_invoice_table_header_period">{{'INSTALLATIONS.INVOICE.PERIOD' | translate}}</th>
                <th id="installation_invoice_table_header_repayment-period">{{'INSTALLATIONS.INVOICE.REPAYMENT_PERIOD' | translate}}</th>
                <th id="installation_invoice_table_header_paid-period">{{'INSTALLATIONS.INVOICE.PAID_PERIOD' | translate}}</th>
                <th id="installation_invoice_table_header_remaining-period">{{'INSTALLATIONS.INVOICE.REMAINING_PERIOD' | translate}}</th>
                <th id="installation_invoice_table_header_monthly-repayment-amount">{{'INSTALLATIONS.INVOICE.MONTHLY_REPAYMENT_AMOUNT' | translate}}</th>
                <th id="installation_invoice_table_header_amount-paid">{{'INSTALLATIONS.INVOICE.AMOUNT_PAID' | translate}}</th>
                <th id="installation_invoice_table_header_balance">{{'INSTALLATIONS.INVOICE.BALANCE' | translate}}</th>
                <th id="installation_invoice_table_header_last-payment-date">{{'INSTALLATIONS.INVOICE.LAST_PAYMENT_DATE' | translate}}</th>
                <th id="installation_invoice_table_header_status">{{'COMMON.ASSET_STATUS.STATUS' | translate}}</th>
                <th id="installation_invoice_table_header_actions"></th>
              </tr>
            </thead>
            <tbody>
              <tr [id]="'installation_invoice_table_row-' + (i + 1)" *ngFor="let invoice of invoices; let i = index">
                <td [id]="'installation_invoice_table_invoice-id-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.invoiceId | hasValue }}</td>
                <td [id]="'installation_invoice_table_invoice-date-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.invoiceDate | date : 'dd/MM/yyyy' | hasValue }}</td>
                <td [id]="'installation_invoice_table_vendor-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.vendor | hasValue }}</td>
                <td [id]="'installation_invoice_table_meter-price-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.meterPrice != null ? currency + ' ' + (invoice.meterPrice | number : '1.2-2') : '----' }}</td>
                <td [id]="'installation_invoice_table_no-of-meters-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.numberOfMeters | hasValue }}</td>
                <td [id]="'installation_invoice_table_period-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.period | hasValue }}</td>
                <td [id]="'installation_invoice_table_repayment-period-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.repaymentPeriod | hasValue }}</td>
                <td [id]="'installation_invoice_table_paid-period-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.paidPeriod | hasValue }}</td>
                <td [id]="'installation_invoice_table_remaining-period-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.remainingPeriod | hasValue }}</td>
                <td [id]="'installation_invoice_table_monthly-repayment-amount-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.monthlyRepaymentAmount != null ? currency + ' ' + (invoice.monthlyRepaymentAmount | number : '1.2-2') : '----' }}</td>
                <td [id]="'installation_invoice_table_amount-paid-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.amountPaid != null ? currency + ' ' + (invoice.amountPaid | number : '1.2-2') : '----' }}</td>
                <td [id]="'installation_invoice_table_balance-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.balance != null ? currency + ' ' + (invoice.balance | number : '1.2-2') : '----' }}</td>
                <td [id]="'installation_invoice_table_last-payment-date-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">{{ invoice.lastPaymentDate | date : 'dd/MM/yyyy' | hasValue }}</td>
                <td [id]="'installation_invoice_table_status-' + (i + 1)" (click)="setInvoiceFilterStorage()" [routerLink]="'/installations/invoice/details/' + invoice.id">
                  <div
                    *ngIf="invoice.status"
                    class="v-2"
                    [ngClass]="{
                      'orange-status': invoice.status == 'Pending',
                      'green-status': invoice.status == 'Active',
                      'blue-status': invoice.status == 'Complete'
                    }"
                  >
                    {{ invoice.status }}
                  </div>
                  <div *ngIf="!invoice.status">
                    ----
                  </div>
                </td>
                <td class="more-icon">
                  <ng-container *ngIf="(invoiceTab == DtMeterInstallationInvoiceStatus.Active && permissionsService.isDtMeterInstallationAcknowledgeRepaymentAllowed)
                    || (invoiceTab == DtMeterInstallationInvoiceStatus.Approval && permissionsService.isDtMeterInstallationApproveInvoiceAllowed)">
                    <div [id]="'installation_invoice_table_actions-' + (i + 1)" data-bs-toggle="dropdown" aria-expanded="false">
                      <img src="../../assets/icons/more-icon.svg" alt="More icon" class="more-icon" />
                    </div>
                    <ul class="dropdown-menu">
                      <li *ngIf="invoiceTab == DtMeterInstallationInvoiceStatus.Approval && permissionsService.isDtMeterInstallationApproveInvoiceAllowed"
                        [id]="'installation_invoice_approve-' + (i + 1)" data-bs-toggle="modal" data-bs-target="#approveDtMeterInstallationInvoice" (click)="openApproveInvoiceModal(invoice)">
                        <img src="../../assets/icons/approveInvoice.svg" alt="Approve invoice icon" />
                        <span>{{'INSTALLATIONS.APPROVE.APPROVE_INVOICE' | translate}}</span>
                      </li>
                      <li *ngIf="invoiceTab == DtMeterInstallationInvoiceStatus.Active && permissionsService.isDtMeterInstallationAcknowledgeRepaymentAllowed"
                        [id]="'installation_invoice_acknowledge-' + (i + 1)" data-bs-toggle="modal" data-bs-target="#acknowledgeRepayment" (click)="openAcknowledgeModal(invoice)">
                        <img src="../../assets/icons/thumbs-up.svg" alt="Acknowledge icon" />
                        <span>{{'INSTALLATIONS.INVOICE.ACKNOWLEDGE_REPAYMENT' | translate}}</span>
                      </li>
                    </ul>
                  </ng-container>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div>
          <app-paging
            *ngIf="invoiceCount > 0"
            [pageSize]="invoicePageSize"
            [count]="invoiceCount"
            [currentPage]="invoiceCurrentPage"
            [useDirect]="true"
            (pageChange)="invoicePageChange($event)"
          ></app-paging>
        </div>
      </div>
    </div>
    <div class="table-root-child" *ngIf="!invoiceTab">
      <div
        class="table-action-wrapper d-flex align-items-center justify-content-between"
      >
        <div id="installation_search" class="search-input">
          <img
            src="../../assets/icons/search.svg"
            alt="Search icon"
            (click)="search()"
          />
          <input
            type="text"
            [placeholder]="'COMMON.SEARCH' | translate"
            [(ngModel)]="searchText"
            (keydown.enter)="search()"
            (ngModelChange)="this.searchTextUpdate.next($event)"
          />
        </div>
   <div id="installation_search-by" class="search-type-picker">
          <div [title]="selectedSearchTypeDisplay | translate" class="dropdown"
            (click)="showSelectSearchType = !showSelectSearchType" click-stop-propagation>
            <span>{{'COMMON.BY' | translate}}:</span>
            <span>{{ selectedSearchTypeDisplay | translate }}</span>
            <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
          </div>
          <div class="dropdown-opened" *ngIf="showSelectSearchType">
            <div [id]="'installation_search-by-' + (i + 1)" (click)="selectSearchType(searchType)"
              *ngFor="let searchType of searchByOptions; let i = index">
              <div>{{ searchType.translation | translate }}</div>
            </div>
          </div>
        </div>
        <div class="ml-auto d-flex">
          <div>
            <div class="d-flex">
              <div id="installation_date-from" class="datepicker-container" style="width: 24rem;">
                <label for="dateFrom"> {{'COMMON.FROM' | translate}}: </label>
                <input
                  type="date"
                  id="dateFrom"
                  name="dateFrom"
                  [ngClass]="
                    dateFrom > dateTo
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  "
                  [(ngModel)]="dateFrom"
                  (change)="datesValid() == true && search()"
                />
              </div>

              <div id="installation_date-to" class="datepicker-container">
                <label for="dateTo" class="right-label"> {{'COMMON.TO' | translate}}: </label>
                <input
                  type="date"
                  id="dateTo"
                  name="dateTo"
                  [ngClass]="
                    dateFrom > dateTo
                      ? 'btn datepicker-icon-error'
                      : 'btn datepicker-icon'
                  "
                  [(ngModel)]="dateTo"
                  (change)="datesValid() == true && search()"
                />
              </div>
            </div>
          </div>
          <div
            id="installation_sort-by"
            class="sort-by-root"
            (click)="showSortBy = !showSortBy"
            click-stop-propagation
          >
            <div class="dropdown">
              <span>{{'COMMON.SORT_BY.TITLE' | translate}}:</span>
              <span>{{ sortByName | translate }}</span>
              <span
                ><img
                  src="../../assets/icons/gray-arrow-down.svg"
                  alt="Gray arrow down"
              /></span>
            </div>
            <div class="dropdown-opened" *ngIf="showSortBy">
              <div id="installation_sort-by-newest" (click)="sortBy(sortByOptions.NEWEST)">{{'COMMON.SORT_BY.NEWEST' | translate}}</div>
              <div id="installation_sort-by-oldest" (click)="sortBy(sortByOptions.OLDEST)">{{'COMMON.SORT_BY.OLDEST' | translate}}</div>
            </div>
          </div>
          <button
            class="btn btn-icon"
            (click)="download()"
          >
            <span>{{'COMMON.DOWNLOAD' | translate}}</span>
          </button>
          <button id="installation_approve-meter" class="btn btn-primary btn-approve"
            *ngIf="currentTab == 8 && selectedMeterTab === MeterTypeTab.DtMeter &&
                   permissionsService.hasDashboardConfigMeterApprovalAndRepayment &&
                   permissionsService.isDtMeterInstallationApproveMeterAllowed"
            data-bs-toggle="modal" data-bs-target="#approveDtMeterInstallation"
            (click)="openApproveModal(ApproveMode.Meter)">
            <img src="../../assets/icons/approveMeter.svg" alt="Approve meter" />
            <span>{{'INSTALLATIONS.APPROVE.APPROVE_METER' | translate}}</span>
          </button>
          <div *ngIf="currentTab == 4 && selectedMeterTab === MeterTypeTab.CustomerMeter && permissionsService.hasDashboardConfigInstallation && permissionsService.isInstallationCreateEditAllowed">
            <button
              class="btn btn-primary btn-upload"
              (click)="showUpload = !showUpload"
              click-stop-propagation
            >
              <img
                src="../../assets/icons/chevron-down.svg"
                alt="Chevron down"
              />
            </button>
            <div *ngIf="showUpload" class="xlsx-upload-dropdown" click-stop-propagation>
              <div class="xlsx-upload" [routerLink]="'/upload/6/' + utilityId">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" /></div>
                <div>{{'COMMON.UPLOAD_XLSX' | translate}}</div>
              </div>
              <div class="xlsx-upload" [routerLink]="'/upload/36/' + utilityId">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" /></div>
                <div>{{'INSTALLATIONS.BULK_ASSIGNMENT' | translate}}</div>
              </div>
            </div>
          </div>
          <div *ngIf="currentTab == 4 && selectedMeterTab === MeterTypeTab.DtMeter && (permissionsService.isDtMeterInstallationAuthorizeMeteringAllowed || permissionsService.isDtMeterInstallationVendorAssignmentAllowed || permissionsService.isDtMeterInstallationCreateEditAllowed)">
            <button
              class="btn btn-primary btn-upload"
              (click)="showUpload = !showUpload"
              click-stop-propagation
            >
              <img
                src="../../assets/icons/chevron-down.svg"
                alt="Chevron down"
              />
            </button>
            <div *ngIf="showUpload" class="xlsx-upload-dropdown" click-stop-propagation>
              <div class="xlsx-upload" [routerLink]="'/upload/40/' + utilityId" *ngIf="permissionsService.isDtMeterInstallationAuthorizeMeteringAllowed">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" /></div>
                <div>{{'INSTALLATIONS.AUTHORIZE_METERING' | translate}}</div>
              </div>
              <div class="xlsx-upload" [routerLink]="'/upload/41/' + utilityId" *ngIf="permissionsService.isDtMeterInstallationVendorAssignmentAllowed">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" /></div>
                <div>{{'INSTALLATIONS.BULK_VENDOR_ASSIGNMENT' | translate}}</div>
              </div>
              <div class="xlsx-upload" [routerLink]="'/upload/43/' + utilityId" *ngIf="permissionsService.isDtMeterInstallationVendorAssignmentAllowed">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" /></div>
                <div>{{'INSTALLATIONS.BULK_VENDOR_REASSIGNMENT' | translate}}</div>
              </div>
              <div class="xlsx-upload" [routerLink]="'/upload/42/' + utilityId" *ngIf="permissionsService.isDtMeterInstallationCreateEditAllowed">
                <div><img src="../../assets/icons/upload-arrow.svg" alt="Upload arrow" /></div>
                <div>{{'INSTALLATIONS.BULK_INSTALLER_ASSIGNMENT' | translate}}</div>
              </div>
            </div>
          </div>
          <button class="btn btn-primary btn-add-new" (click)="openCreateModal()" *ngIf="currentTab == 4 && ((selectedMeterTab === MeterTypeTab.CustomerMeter && permissionsService.hasDashboardConfigInstallation && permissionsService.isInstallationCreateEditAllowed) ||
                                                                                                          (selectedMeterTab === MeterTypeTab.DtMeter && permissionsService.hasDashboardConfigDtMeterInstallation && (permissionsService.isDtMeterInstallationCreateEditAllowed || permissionsService.isDtMeterInstallationVendorAssignmentAllowed)))">
            <img src="../../assets/icons/plus.svg" alt="Plus icon" />
            <span>{{'INSTALLATIONS.NEW' | translate}}</span>
          </button>
        </div>
      </div>

      <div class="filter">
        <div class="filter-list">
          {{'COMMON.FILTER' | translate}}
          <app-multi-select-dropdown class="multiselect"
                                     id="installation_region_filter"
                                     [clicked] = "clicked"
                                     [items]="hasCimDataIntegration ? geographicalRegions : regions"
                                     [label]="'COMMON.BU.PLURAL'"
                                     [showMore]="false"
                                     [requireApply]="true"
                                     (shareIndividualCheckedList)="hasCimDataIntegration ? selectGeographicalRegion($event) : selectRegion($event)"
                                     >
          </app-multi-select-dropdown>
          <app-multi-select-dropdown class="multiselect"
                                     id="installation_area_filter"
                                     [clicked] = "clicked"
                                     [items]="hasCimDataIntegration ? subGeographicalRegions : areas"
                                     [label]="'COMMON.UT.PLURAL'"
                                     [showMore]="false"
                                     [requireApply]="true"
                                     (shareIndividualCheckedList)="selectArea($event)"
                                     (applyFilterEmitter)="reloadTable(1)"
                                     >
          </app-multi-select-dropdown>
          <ng-container *ngIf="selectedMeterTab === MeterTypeTab.DtMeter">
            <select *ngIf="!hasCimDataIntegration" id="installation_dt-type_filter" name="dt-type-select" (change)="selectDtType($event)" class="form-select" >
              <option value="0" [selected]="dtType == 0" disabled>{{'TRANSFORMERS.DT_TYPE' | translate}}</option>
              <option [id]="'installation_dt-type_filter-' + (i + 1)" [selected]="dtType == o.value" *ngFor="let o of dtTypeOptions; let i = index" value="{{o.value}}">
                  {{o.translation | translate}}
              </option>
            </select>
            <select id="installation_rating_filter" name="rating-select" (change)="selectDtRating($event)" class="form-select" >
              <option value="0" [selected]="dtRating == 0" disabled>{{'TRANSFORMERS.DT_RATING' | translate}}</option>
              <option [id]="'installation_rating_filter-' + (i + 1)" [selected]="dtRating == o.id" *ngFor="let o of dtRatingOptions; let i = index" value="{{o.id}}">
                  {{o.kvaRating}}
              </option>
            </select>
            <select id="installation_dt-meter-status_filter" name="dt-meter-status-select" (change)="selectDtMeterStatus($event)" class="form-select" >
              <option value="0" [selected]="dtMeterStatus == 0" disabled>{{'COMMON.MBC_DETAILS.METER_STATUS' | translate}}</option>
              <option [id]="'installation_dt-meter-status_filter-' + (i + 1)" [selected]="dtMeterStatus == o.value" *ngFor="let o of meterStatusOptions; let i = index" value="{{o.value}}">
                  {{o.translation | translate}}
              </option>
            </select>
            <ng-container *ngIf="currentTab == 8">
              <app-period-picker id="installation_period_filter"
                                 [initialYear]="periodYear || undefined"
                                 [initialMonths]="periodMonths"
                                 (apply)="onPeriodApply($event)">
              </app-period-picker>
              <select id="installation_dt-vendor_filter" name="dt-vendor-select" (change)="selectMapVendor($event)" class="form-select" >
                <option value="0" [selected]="selectedOrganizationId == 0" disabled>{{'INSTALLATIONS.INVOICE.VENDOR' | translate}}</option>
                <option [id]="'installation_dt-vendor_filter-' + (i + 1)" [selected]="selectedOrganizationId == o.id" *ngFor="let o of organizations; let i = index" value="{{o.id}}">
                    {{o.name}}
                </option>
              </select>
            </ng-container>
          </ng-container>
          <ng-container *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">
            <select id="installation_tariff_filter" name="tariff-select" (change)="selectTariff($event)" class="form-select" >
              <option value="0" [selected]="tariff == 0" disabled>{{'COMMON.TARIFF.SINGLE' | translate}}</option>
              <option [id]="'installation_tariff_filter-' + (i + 1)" [selected]="tariff == o.id" *ngFor="let o of tariffs; let i = index" value="{{o.id}}">
                  {{o.name}}
              </option>
            </select>
            <select id="installation_customer-type_filter" name="type-select" (change)="selectCustomerType($event)" class="form-select" >
              <option value="0" [selected]="customerType == 0" disabled>{{'COMMON.MBC_DETAILS.CUSTOMER_TYPE' | translate}}</option>
              <option [id]="'installation_customer-type_filter-' + (i + 1)" [selected]="customerType == o.value" *ngFor="let o of customerTypeOptions; let i = index" value="{{o.value}}">
                  {{o.translation | translate}}
              </option>
            </select>
            <select id="installation_customer-phase_filter" name="phase-select" (change)="selectCustomerPhase($event)" class="form-select" >
              <option value="0" [selected]="customerPhase == -1" disabled>{{'COMMON.CUSTOMER.CUSTOMER_PHASE' | translate}}</option>
              <option [id]="'installation_customer-phase_filter-' + (i + 1)" [selected]="customerPhase == o.value" *ngFor="let o of customerPhaseOptions; let i = index" value="{{o.value}}">
                  {{o.translation | translate}}
              </option>
            </select>
            <select id="installation_meter-status_filter" name="status-select" (change)="selectMeterStatus($event)" class="form-select" >
              <option value="0" [selected]="meterStatus == 0" disabled>{{'COMMON.MBC_DETAILS.METER_STATUS' | translate}}</option>
              <option [id]="'installation_meter-status_filter-' + (i + 1)" [selected]="meterStatus == o.value" *ngFor="let o of meterStatusOptions; let i = index" value="{{o.value}}">
                  {{o.translation | translate}}
              </option>
            </select>
            <select id="installation_map-vendor_filter" name="map-vendor-select" (change)="selectMapVendor($event)" class="form-select" >
              <option value="0" [selected]="selectedOrganizationId == 0" disabled>{{'SURVEYS.MAP_VENDOR' | translate}}</option>
              <option [id]="'installation_map-vendor_filter-' + (i + 1)" [selected]="selectedOrganizationId == o.id" *ngFor="let o of organizations; let i = index" value="{{o.id}}">
                  {{o.name}}
              </option>
            </select>
          </ng-container>
          <select *ngIf="currentTab == 1 && selectedMeterTab === MeterTypeTab.CustomerMeter" id="installation_submission-status_filter" name="submission-status-select" (change)="selectSubmissionStatus($event)" class="form-select" >
            <option value="0" [selected]="submissionStatus == 0" disabled>{{'COMMON.ASSET_STATUS.STATUS' | translate}}</option>
            <option [id]="'installation_submission-status_filter-' + (i + 1)" [selected]="submissionStatus == o.value" *ngFor="let o of submissionStatusOptions; let i = index" value="{{o.value}}">
                {{o.translation | translate}}
            </option>
          </select>
          <select *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter" id="installation_reopen-status_filter" name="reopen-status-select" (change)="selectReopenStatus($event)" class="form-select" >
            <option value="0" [selected]="reopenStatus == 0" disabled>{{'SURVEYS.REQUEST_INSTANCE' | translate}}</option>
            <option [id]="'installation_reopen-status_filter-' + (i + 1)" [selected]="reopenStatus == o.value" *ngFor="let o of reopenStatusOptions; let i = index" value="{{o.value}}">
                {{o.translation | translate}}
            </option>
          </select>
        </div>
        <div *ngIf="selectedFilters.length > 0">
          <app-filter-checklist [filters]="selectedFilters" 
                                (resetFilterEmitter)="resetFilter($event)"
                                (removeFilterEmitter)="removeFilter($event)"
                                >
          </app-filter-checklist>
        </div>
      </div>
      <div class="table">
        <div *ngIf="installations">
          <div class="table-scroll">
          <table class="table border-bottom">
            <thead class="table-light">
              <tr>
                <th id="installation_table_header_checkbox">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    [checked]="isAllCheckBoxChecked()"
                    (change)="checkAllCheckBox($event)"
                  />
                </th>
                <th id="installation_table_header_map-id" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{'SURVEYS.MAP_ID' | translate}}</th>
                <th id="installation_table_header_dt-name" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter">{{'COMMON.DT_NAME' | translate}}</th>
                <th id="installation_table_header_dt-number" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter">{{'COMMON.DT_NUMBER' | translate}}</th>
                <th id="installation_table_header_acc-no" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{'COMMON.MBC_DETAILS.ACCOUNT_NO' | translate}}</th>
                <th id="installation_table_header_building-owner" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{'COMMON.TABLE_HEADERS.BUILDING_OWNER' | translate}}</th>
                <th id="installation_table_header_address" *ngIf="!(selectedMeterTab === MeterTypeTab.DtMeter && hasCimDataIntegration)">{{'COMMON.ADDRESS' | translate}}</th>
                <th id="installation_table_header_dt-type" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && !hasCimDataIntegration">{{'TRANSFORMERS.DT_TYPE' | translate}}</th>
                <th id="installation_table_header_rating" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter">{{'TRANSFORMERS.DT_RATING' | translate}}</th>
                <th id="installation_table_header_tariff" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{'COMMON.CURRENT_TARIFF' | translate}}</th>
                <th id="installation_table_header_region">{{'COMMON.BU.SINGLE' | translate}}</th>
                <th id="installation_table_header_district">{{'COMMON.UT.SINGLE' | translate}}</th>
                <th id="installation_table_header_feeder">{{'COMMON.FEEDER' | translate}}</th>
                <th id="installation_table_header_dt" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{'TRANSFORMERS.DT' | translate}}</th>
                <th id="installation_table_header_meter-number">{{'COMMON.MBC_DETAILS.METER_NO' | translate}}</th>
                <th id="installation_table_header_old-meter-number">{{'INSTALLATIONS.OLD_METER_NO' | translate}}</th>
                <th id="installation_table_header_map-vendor" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{'SURVEYS.MAP_VENDOR' | translate}}</th>
                <th id="installation_table_header_vendor" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && currentTab == 8">{{'INSTALLATIONS.INVOICE.VENDOR' | translate}}</th>
                <th id="installation_table_header_meter-price" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && currentTab == 8">{{'INSTALLATIONS.INVOICE.METER_PRICE' | translate}}</th>
                <th id="installation_table_header_installation-date" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && currentTab == 8">{{'INSTALLATIONS.INSTALLATION_DATE' | translate}}</th>
                <th id="installation_table_header_period" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && currentTab == 8">{{'INSTALLATIONS.INVOICE.PERIOD' | translate}}</th>
                <th id="installation_table_header_project-type" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{'SURVEYS.PROJECT_TYPE' | translate}}</th>
                <th id="installation_table_header_service-request-type" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{'NEW_SERVICE.SERVICE_REQUEST_TYPE' | translate}}</th>
                <th id="installation_table_header_vendor" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && (currentTab==1 || currentTab==2 || currentTab==3 || currentTab==4)">{{'INSTALLATIONS.VENDOR' | translate}}</th>
                <th id="installation_table_header_assigner-date" *ngIf="currentTab==4">{{'COMMON.TABLE_HEADERS.ASSIGNED_DATE' | translate}}</th>
                <th id="installation_table_header_submitted-date" *ngIf="currentTab==1">{{'COMMON.TABLE_HEADERS.SUBMITTED_DATE' | translate}}</th>
                <th id="installation_table_header_rejected-date" *ngIf="currentTab==3">{{'COMMON.TABLE_HEADERS.REJECTED_DATE' | translate}}</th>
                <th id="installation_table_header_approved-date" *ngIf="currentTab==2">{{'COMMON.TABLE_HEADERS.APPROVED_DATE' | translate}}</th>

                <th id="installation_table_header_assigned">{{'COMMON.MBC_DETAILS.ASSIGNED' | translate}}</th>
                <th id="installation_table_header_assigned-by" *ngIf="currentTab==1 || currentTab==4">{{'COMMON.TABLE_HEADERS.ASSIGNED_BY' | translate}}</th>
                <th id="installation_table_header_rejected-by" *ngIf="currentTab==3">{{'COMMON.TABLE_HEADERS.REJECTED_BY' | translate}}</th>
                <th id="installation_table_header_approved-by" *ngIf="currentTab==2">{{'COMMON.TABLE_HEADERS.APPROVED_BY' | translate}}</th>

                 <th id="installation_table_header_reopen-status" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{'SURVEYS.REQUEST_INSTANCE' | translate}}</th>
                <th id="installation_table_header_current-status">{{'COMMON.TABLE_HEADERS.CURRENT_STATUS' | translate}}</th>
              </tr>
            </thead>
            <tbody>
              <tr [id]="'installation_table_row-' + (i + 1)" *ngFor="let installation of installations; let i = index">
                <td [id]="'installation_table_checkbox-' + (i + 1)">
                  <input
                    type="checkbox"
                    class="form-check-input"
                    value="{{ installation.id }}"
                  />
                </td>
                <td [id]="'installation_table_map-id-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{ installation.mapId | hasValue }}</td>
                <td [id]="'installation_table_dt-name-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter">{{ installation.dtName | hasValue }}</td>
                <td [id]="'installation_table_dt-number-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter">{{ installation.dtNumber | hasValue }}</td>
                <td [id]="'installation_table_acc-no-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{ installation.accountNumber | hasValue }}</td>
                <td [id]="'installation_table_acc-name-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{ installation.accountName | hasValue }}</td>
                <td [id]="'installation_table_address-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="!(selectedMeterTab === MeterTypeTab.DtMeter && hasCimDataIntegration)">{{ installation.address | hasValue }}</td>
                <td [id]="'installation_table_dt-type-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && !hasCimDataIntegration">{{ installation.dtType | enumTranslate | translate }}</td>
                <td [id]="'installation_table_rating-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter">{{ installation.rating | hasValue }}</td>
                <td [id]="'installation_table_tariff-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{ installation.currentTariff | hasValue }}</td>
                <td [id]="'installation_table_region-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)">{{ (selectedMeterTab === MeterTypeTab.DtMeter ? installation.region : (hasCimDataIntegration ? installation.geographicalRegion : installation.region)) | hasValue }}</td>
                <td [id]="'installation_table_district-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)">{{ (selectedMeterTab === MeterTypeTab.DtMeter ? installation.district : (hasCimDataIntegration ? installation.subgeographicalRegion : installation.district)) | hasValue }}</td>
                <td [id]="'installation_table_feeder-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)">{{ (selectedMeterTab === MeterTypeTab.DtMeter ? installation.feederName : (hasCimDataIntegration ? installation.acLineName : installation.feederName)) | hasValue }}</td>
                <td [id]="'installation_table_dt-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{ (hasCimDataIntegration ? installation.substationName : installation.dtName) | hasValue }}</td>
                <td [id]="'installation_table_meter-number-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)">{{ installation.meterNumber | hasValue }}</td>
                <td [id]="'installation_table_old-meter-number-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)">{{ installation.oldMeterNumber | hasValue }}</td>
                <td [id]="'installation_table_map-vendor-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{ installation.mapVendorName | hasValue }}</td>
                <td [id]="'installation_table_vendor-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && currentTab == 8">{{ installation.mapVendorName | hasValue }}</td>
                <td [id]="'installation_table_meter-price-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && currentTab == 8">{{ installation.meterPrice != null ? currency + ' ' + (installation.meterPrice | number : '1.2-2') : '----' }}</td>
                <td [id]="'installation_table_installation-date-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && currentTab == 8">{{ installation.installationDate | date:'longDate' | hasValue }}</td>
                <td [id]="'installation_table_period-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && currentTab == 8">{{ installation.installationDate | date:'MMMM, y' | hasValue }}</td>
                <td [id]="'installation_table_project-type-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{ installation.projectType | hasValue }}</td>
                <td [id]="'installation_table_service-request-type-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">{{ installation.subServiceType | hasValue }}</td>
                <td [id]="'installation_table_vendor-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="selectedMeterTab === MeterTypeTab.DtMeter && (currentTab==1 || currentTab==2 || currentTab==3 || currentTab==4)">{{ installation.mapVendorName | hasValue }}</td>
                <td [id]="'installation_table_assigned-date-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="currentTab==4">{{installation.assignedDate | hasValue}} </td>
                <td [id]="'installation_table_submitted-date-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="currentTab==1">{{installation.submittedDate | hasValue}} </td>
                <td [id]="'installation_table_rejected-date-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="currentTab==3">{{installation.rejectedDate | hasValue}} </td>
                <td [id]="'installation_table_approved-date-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="currentTab==2">{{installation.approvedDate | hasValue}} </td>

                <td [id]="'installation_table_assigned-user-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)">{{installation.assignedUser | hasValue}} </td>
                <td [id]="'installation_table_assigned-by-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="currentTab==1 || currentTab==4">{{installation.assignedBy | hasValue}} </td>
                <td [id]="'installation_table_rejected-by-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="currentTab==3">{{installation.rejectedBy | hasValue}} </td>
                <td [id]="'installation_table_approved-by-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)" *ngIf="currentTab==2" >{{installation.approvedBy | hasValue}} </td>
                <td [id]="'installation_table_reopen-status-' + (i + 1)" (click)="setFilterStorage()"
                  [routerLink]="['details', installation.id]" *ngIf="selectedMeterTab === MeterTypeTab.CustomerMeter">
                  <div *ngIf="installation.reopenStatus">
                    {{'SURVEYS.REOPEN_STATUS.' + installation.reopenStatus | uppercase | translate}}
                  </div>
                  <div *ngIf="!installation.reopenStatus">{{ installation.reopenStatus | hasValue }}</div>
                </td>
                <td [id]="'installation_table_current-status-' + (i + 1)" (click)="setFilterStorage()" [routerLink]="getDetailsRouterLink(installation)">
                  <div
                    *ngIf="installation.currentStatus"
                    class="building-status"
                    [ngClass]="{
                      'assigned-building':
                        installation.currentStatus == 'Assigned',
                      'rejected-building':
                        installation.currentStatus == 'Rejected',
                      'approved-building':
                        installation.currentStatus == 'Approved',
                      'submitted-building':
                      installation.currentStatus == 'Submitted',
                      'resubmitted-building':
                        installation.currentStatus == 'Resubmitted',
                      'pending-building':
                        installation.currentStatus == 'Pending',
                      'submitted-building awaiting-approval-building':
                        installation.currentStatus == 'AwaitingApproval'
                    }"
                  >
                  {{ installation.currentStatus == 'Pending' ? "In progress" : (installation.currentStatus == 'AwaitingApproval' ? 'Awaiting Approval' : installation.currentStatus) }}
                </div>
                </td>
              </tr>
            </tbody>
          </table>
          </div>
          <div>
            <app-paging
              *ngIf="count > 0"
              [pageSize]="pageSize"
              [count]="count"
              [currentPage]="currentPage"
              [useDirect]="true"
              (pageChange)="pageChange($event)"
            ></app-paging>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>


<div class="modal fade" id="approveDtMeterInstallation" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered approve-dialog">
    <div class="modal-content approve-modal-content">
      <div class="approve-body">
        <h2 class="approve-title">
          {{ (approveMode === ApproveMode.Meter ? 'INSTALLATIONS.APPROVE.APPROVE_METERS_TITLE' : 'INSTALLATIONS.APPROVE.APPROVE_INVOICE_TITLE') | translate }}
        </h2>
        <p class="approve-prompt">
          {{ (approveMode === ApproveMode.Meter ? 'INSTALLATIONS.APPROVE.METER_PROMPT' : 'INSTALLATIONS.APPROVE.INVOICE_PROMPT') | translate }}
        </p>
        <div class="approve-field">
          <label for="approveVendor">{{ 'COMMON.MAP_VENDOR' | translate }}</label>
          <select id="approveVendor" name="approveVendor" class="form-select"
            [(ngModel)]="selectedApproveVendorId" (ngModelChange)="onApproveVendorChange()">
            <option [ngValue]="undefined" disabled>{{ 'COMMON.MAP_VENDOR' | translate }}</option>
            <option *ngFor="let vendor of approveVendors" [ngValue]="vendor.id">{{ vendor.name }}</option>
          </select>
        </div>
        <div class="approve-field">
          <label for="approvePeriod">{{ 'INSTALLATIONS.APPROVE.PERIOD' | translate }}</label>
          <select id="approvePeriod" name="approvePeriod" class="form-select"
            [disabled]="!selectedApproveVendorId" [(ngModel)]="selectedApprovePeriod">
            <option [ngValue]="undefined" disabled>{{ 'INSTALLATIONS.APPROVE.MONTH_YEAR' | translate }}</option>
            <option *ngFor="let period of approvePeriodOptions" [ngValue]="period">
              {{ getApprovePeriodLabel(period) }}
            </option>
          </select>
        </div>

        <div class="approve-actions">
          <button type="button" class="btn approve-cancel-btn" data-bs-dismiss="modal">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="button" class="btn approve-confirm-btn" (click)="confirmApprove()">
            {{ 'INSTALLATIONS.APPROVE.CONFIRM' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="otpVerification" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered otp-dialog">
    <div class="modal-content otp-modal-content">
      <div class="otp-body">
        <h2 class="otp-title">{{ 'INSTALLATIONS.APPROVE.OTP_TITLE' | translate }}</h2>

        <div class="otp-info-row">
          <div class="otp-info-icon">
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V9H11V15ZM11 7H9V5H11V7Z" fill="#888"/>
            </svg>
          </div>
          <div class="otp-info-text">
            {{ 'INSTALLATIONS.APPROVE.OTP_SENT_TO' | translate }} {{ otpMaskedEmail }}
          </div>
        </div>

        <div class="otp-input-section">
          <label class="otp-label">{{ 'INSTALLATIONS.APPROVE.ENTER_OTP' | translate }}</label>
          <div class="otp-digits" [class.otp-digits-error]="otpError">
            <input #otpInput0 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
              [(ngModel)]="otpDigits[0]" (input)="onOtpDigitInput($event, 0)" (keydown)="onOtpKeyDown($event, 0)" (paste)="onOtpPaste($event)" />
            <input #otpInput1 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
              [(ngModel)]="otpDigits[1]" (input)="onOtpDigitInput($event, 1)" (keydown)="onOtpKeyDown($event, 1)" (paste)="onOtpPaste($event)" />
            <input #otpInput2 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
              [(ngModel)]="otpDigits[2]" (input)="onOtpDigitInput($event, 2)" (keydown)="onOtpKeyDown($event, 2)" (paste)="onOtpPaste($event)" />
            <input #otpInput3 type="text" maxlength="1" class="otp-digit" [class.otp-digit-error]="otpError"
              [(ngModel)]="otpDigits[3]" (input)="onOtpDigitInput($event, 3)" (keydown)="onOtpKeyDown($event, 3)" (paste)="onOtpPaste($event)" />
          </div>
        </div>

        <div class="otp-resend-row" *ngIf="!otpError">
          {{ 'INSTALLATIONS.APPROVE.DIDNT_RECEIVE_CODE' | translate }}
          <ng-container *ngIf="otpResendSeconds > 0">
            {{ 'INSTALLATIONS.APPROVE.RESEND_CODE_IN' | translate }} <span class="otp-timer">{{ otpResendSeconds }}s</span>
          </ng-container>
          <a *ngIf="otpResendSeconds === 0" class="otp-resend-link" (click)="resendOtp()">
            {{ 'INSTALLATIONS.APPROVE.RESEND_CODE' | translate }}
          </a>
        </div>

        <div class="otp-error-row" *ngIf="otpError">
          <svg width="14" height="14" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#dc3545"/>
          </svg>
          <span>
            {{ otpError }}
            <a *ngIf="otpExpired" class="otp-resend-link" (click)="resendOtp()">
              {{ 'INSTALLATIONS.APPROVE.RESEND_CODE' | translate }}
            </a>
          </span>
        </div>

        <div class="otp-actions">
          <button type="button" class="btn otp-cancel-btn" data-bs-dismiss="modal" (click)="closeOtpModal()">
            {{ 'COMMON.CANCEL' | translate }}
          </button>
          <button type="button" class="btn otp-continue-btn" [disabled]="otpCode.length < 4 || otpRequestInProgress"
            (click)="submitOtp()">
            {{ (otpRequestInProgress ? 'INSTALLATIONS.APPROVE.VERIFYING' : 'INSTALLATIONS.APPROVE.SUBMIT') | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="approveDtMeterInstallationInvoice" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ 'INSTALLATIONS.APPROVE.APPROVE_INVOICE_TITLE' | translate }}</h5>
      </div>
      <div class="modal-body approve-modal-body">
        <p class="approve-prompt">{{ 'INSTALLATIONS.APPROVE.INVOICE_PROMPT' | translate }}</p>
      </div>
      <div class="modal-footer approve-modal-footer">
        <button type="button" class="btn btn-cancel" data-bs-dismiss="modal">
          {{ 'COMMON.CANCEL' | translate }}
        </button>
        <button type="button" class="btn btn-primary" [disabled]="otpRequestInProgress" (click)="confirmApproveInvoice()">
          {{ 'INSTALLATIONS.APPROVE.CONFIRM' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="acknowledgeRepayment" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{'INSTALLATIONS.INVOICE.ACKNOWLEDGE_CONFIRM' | translate}}</h5>
      </div>
      <div class="modal-footer">
        <button id="installation_invoice_acknowledge_confirm" type="button" class="btn btn-primary" (click)="acknowledgeRepayment()">
          {{'INSTALLATIONS.INVOICE.CONFIRM' | translate}}
        </button>
        <button id="installation_invoice_acknowledge_cancel" type="button" class="btn btn-outline-danger" data-bs-dismiss="modal">
          {{'COMMON.CANCEL' | translate}}
        </button>
        <button #closeAcknowledgeModal hidden="true" data-bs-dismiss="modal"></button>
      </div>
    </div>
  </div>
</div>

